import florentinaImg from "./Images/Florentina Tudose.jpg";
import tasneemImg     from "./Images/Tasneem Raslan.jpg";
import hebaImg        from "./Images/Heba fateh.jpeg";
import aymanImg       from "./Images/Ayman Adil.jpg";
import noreenImg      from "./Images/Noreen Hatem Abdelghafar Shaban.jpg";
import budoorImg      from "./Images/Budoor Mohammed.jpeg";
import abdallahImg    from "./Images/Abdallah hisham.jpg";
import ammarImg       from "./Images/Ammar Sadik Shaker.jpeg";
import yousifImg      from "./Images/Yousif Ammar Akram Alasad.jpeg";
import lujainImg      from "./Images/Lujain Nazar.jpeg";
import hussainImg     from "./Images/Hussain Sabeha.jpeg";
import yusufImg       from "./Images/Yusuf hatem abdelghafar shaban.jpg";
import karlImg        from "./Images/Karl Denson.jpg"; 


export const testimonialsData = [
  {
    testimonial: "Himmats Education has been everything I needed to prepare for my IGCSE exams. A few months before the exams, I felt lost and unsure of what the best approach to studying for the most important exams I had ever taken. Himmats Education was there to guide, support and encourage me along the way. ",
    name:        "Florentina Tudose",
    image:       florentinaImg,
    grade:       "3A* 3A",
  },
  
  {
    testimonial: "It was way more than helpful. I learnt a lot in a short amount of time and not only education wise. The studying methods were very efficient and the workload was very bearable.",
    name:        "Heba Fateh",
    image:       hebaImg,
    grade:       "3A* 2A",
  },
  {
    testimonial: "Teachers here were very passionate and thorough with their material, they showed a deep understanding in their respective subjects and would spend a considerable amount of time to make sure students understood the material.",
    name:        "Ayman Adil",
    image:       aymanImg,
    grade:       "4A* 1A",
  },
  {
    testimonial: "Honestly, Himmats Education is our 2nd home encourages to move forward towards our education and achieve high grades. Thanks to Mrs.Tawhida and Abdu for making up such an organisation to let the students believe in themselves again and study in peaceful mood away from stress.  ",
    name:        "Noreen Hatem Abdelghafar Shaban",
    image:       noreenImg,
    grade:       "1A* 3A",
  },
  {
    testimonial: "I had the best experience. The teachers are amazing and it was enjoyable. It made me more confident in myself. You will learn a lot and you will have so much fun.  ",
    name:        "Budoor Mohammed",
    image:       budoorImg,
    grade:       "1A",
  },
  {
    testimonial: "It was fun ,enjoyable and educational. It was a great experience with great teachers. It helped me manage my time through intensive studies ",
    name:        "Abdallah Hisham",
    image:       abdallahImg,
    grade:       "1A* 3A",
  },
  {
    testimonial: "My experience with Himmats was nothing short of excellent. The teaching services provide helped me achieve my full potential. It has taught me discipline as well as integrated a way of using critical thinking in my daily life. ",
    name:        "Ammar Sadik Shaker",
    image:       ammarImg,
    grade:       "3A",
  },
  {
    testimonial: "The teachers were very helpful and they were more like a family rather than a tuition centre, helping students and listening to them during stressful days. Active recall methods was applied by testing students followed by spaced repetition which means having exams every once in a while which helps students transform information to long term memory. Extra hours were also given when required. ",
    name:        "Yousif Ammar Akram Alasad",
    image:       yousifImg,
    grade:       "3A",
  },
  {
    testimonial: "Going in to a home schooling/ tuition life from a school life was scary but the way you guys taught your students and made sure they were comfortable every step of the way was amazing. There’s not one bad thing that I can say about the experience that I had because it was overall fantastic. ",
    name:        "Lujain Nazar",
    image:       lujainImg,
    grade:       "1A* 2A",
  },
  {
    testimonial: "It’s unforgettable how this institution has filled my life…",
    name:        "Hussain Sabeha",
    image:       hussainImg,
    grade:       "1A* 2A",
  },
  {
    testimonial: "The teachers were very helpful and they were more like a family rather than a tuition centre, helping students and listening to them during stressful days. Active recall methods was applied by testing students followed by spaced repetition which means having exams every once in a while which helps students transform information to long term memory. Extra hours were also given when required.",
    name:        "Yusuf Hatem Abdelghafar Shaban",
    image:       yusufImg,
    grade:       "2A",
  },
  {
    testimonial: "I was very well prepared for the IGCSEs. At first I thought that 3 months to prepare was way too little time but with the incredible help that I recieved, getting good grades was a breeze. I cannot thank the teaching team enough! ",
    name:        "Karl Denson",
    image:       karlImg,
    grade:       "3A*",
  },
];


